import React from 'react'

function Required() {
  return (
    <>
    <span style={{color: "red"}}>*</span>
    </>
  )
}

export default Required